import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import './PromotionalDiscounts.css';

export default function PromotionalDiscounts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/discounts', null)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        if (!cancelled) setItems(list);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="promo-discounts" aria-label="Current offers">
      <div className="promo-discounts-inner">
        <div className="promo-discounts-head">
          <h2>Save on longer stays</h2>
          <p className="promo-discounts-sub">
            Automatic discounts apply at checkout when your dates qualify.
            <Link to="/rooms" className="promo-discounts-link">Browse apartments</Link>
          </p>
        </div>
        <ul className="promo-discounts-list">
          {items.map((d) => (
            <li key={d.id} className="promo-discounts-chip">
              <span className="promo-discounts-sr-only">
                {Number(d.percent)}% off {d.name}. Discount applies automatically at checkout.
              </span>
              <div className="promo-discounts-chip-visual" aria-hidden>
                <span className="promo-discounts-chip-shine" aria-hidden />
                <div className="promo-discounts-pct">
                  <span className="promo-discounts-pct-num">{Number(d.percent)}</span>
                  <span className="promo-discounts-pct-suffix">
                    <span className="promo-discounts-pct-symbol">%</span>
                    <span className="promo-discounts-pct-off">off</span>
                  </span>
                </div>
                <div className="promo-discounts-chip-detail">
                  <span className="promo-discounts-text">{d.name}</span>
                  <span className="promo-discounts-chip-tag">Auto at checkout</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
